

export default {

  data() {
    return {
      baseURL: window.location.origin,
      quantidadeItens: 3,
      verMaisIsOpen: false,
      tipo_atual: '',
      tiposInvestimento: {
        acoes: [],
        fiis: [],
        stocks: [],
        reits: [],
        tesouroDireto: []
      }

    }
  },

  mounted() {
    axios.get(`${this.baseURL}/api/ativos_variaveis/?onde_aportar=1`)
      .then(({ data }) => {
        this.tiposInvestimento.acoes = data.filter((i) => i.product_type_name === 'Ações').sort(({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a);
        this.tiposInvestimento.fiis = data.filter((i) => i.product_type_name === 'FII - Fundo de Investimento Imobiliário').sort(({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a);
        this.tiposInvestimento.stocks = data.filter((i) => i.product_type_name === 'Stock').sort(({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a);
        this.tiposInvestimento.reits = data.filter((i) => i.product_type_name === 'REIT').sort(({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a);
      })
      .catch(error => {
        GLOBAL.showToastify(error)
        console.error(error)
      })

    axios.get(`${this.baseURL}/api/titulos_tesouro/?onde_aportar=1`)
      .then(({ data }) => {
        this.tiposInvestimento.tesouroDireto = data.filter((i) => i.product_type_name === 'TesouroDireto').sort(({ distancia_objetivo: a }, { distancia_objetivo: b }) => b - a);
      })
      .catch(error => {
        GLOBAL.showToastify(error)
        console.error(error)
      })
  },

  computed: {
    toggleVerMais() {
      return this.quantidadeItens == 3 ? 'Ver mais' : 'Ver menos';
    }
  },
  methods: {
    outsideClick({ target }) {
      if (target.closest(".btn-vermais")) return
      this.quantidadeItens = 3;
    },
    handleToggle(tipo) {
      const isThree = this.quantidadeItens == 3 ? this.quantidadeItens = this.tiposInvestimento[tipo].length : this.quantidadeItens = 3
      console.log(isThree)
      return isThree
    }
  },




  delimiters: ["{*", "*}"], //delimitadores pra n conflitar com o django

}






